export default __webpack_public_path__ + "static/media/bahia_logo_blanco_fueled.d724118c.svg";